
// для змінення фону на мобілці
import { load } from "../../events/load";

const initHeader = () => {
  const header = document.querySelector('.header');
  
  if (!header) return;

  const scrollThreshold = 10; 
  let ticking = false;
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > scrollThreshold) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  };

  // Додаємо обробник події скролу з оптимізацією
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Перевіряємо початковий стан
  handleScroll();
};

load(initHeader);
